import { deepValue } from '@corratech/pylot-utils'
import { CategoryTree, ProductInterface } from '@pylot-data/pylotschema'

export const getCategoryName = (
    data: ProductInterface | CategoryTree
): string => {
    const simpleCategoryName = deepValue(data, ['category', 'name'])
    if (simpleCategoryName) {
        return simpleCategoryName
    }

    const categories = deepValue(data, ['categories']) ?? data
    if (!Array.isArray(categories)) {
        return ''
    }
    let categoryName = ''
    categories.forEach((item) => {
        if (!categoryName && !!item.name) {
            categoryName = item.name
        }
    })

    return categoryName
}
